import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_TwoFactorForm = _resolveComponent("TwoFactorForm")
  const _component_CredentialsForm = _resolveComponent("CredentialsForm")
  const _component_AuthCard = _resolveComponent("AuthCard")

  return (_openBlock(), _createBlock(_component_AuthCard, null, {
    default: _withCtx(() => [
      (_ctx.twoFactorEmail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Login", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("p", null, " Use your authenticator app to generate a security code for the login. ", -1)),
            _createVNode(_component_TwoFactorForm, {
              onSubmit: _ctx.submitTwoFactor,
              loading: _ctx.loading
            }, null, 8, ["onSubmit", "loading"])
          ]))
        : (_openBlock(), _createBlock(_component_CredentialsForm, {
            key: 1,
            onSubmit: _ctx.submitLogin,
            loading: _ctx.loading
          }, null, 8, ["onSubmit", "loading"]))
    ]),
    _: 1
  }))
}